import { Component, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { GlobalConstants } from './pages/common/global-variables';
import { DOCUMENT } from '@angular/common';
declare function require(name: string): any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(
    private router: Router,
    private update: SwUpdate,
    public GlobalConstants: GlobalConstants,
    @Inject(DOCUMENT) private _document: HTMLDocument
  ) {
    localStorage.setItem('firstLoad', "true");
    this.updateClient();
  }

  ngOnInit() {
    if(this.GlobalConstants && this.GlobalConstants.data){
      if (this.GlobalConstants.data.font_family) {
        this.addStyleSheet(this.GlobalConstants.data.font_family.link)
      }
      if (this.GlobalConstants.data.logo && this.GlobalConstants.data.logo.favicon) {
        this._document.getElementById('appFavicon').setAttribute('href', this.GlobalConstants.data.logo.favicon);
      }
      if (this.GlobalConstants.data.colors && this.GlobalConstants.data.colors.header_bg_color) {
        this._document.getElementById('appColor').setAttribute('content', this.GlobalConstants.data.colors.header_bg_color);
      }
    }
  }
  updateClient() {
    if (!this.update.isEnabled) {
      console.log('Not Enabled');
      return;
    }
    this.update.available.subscribe((event) => {
       this.update.activateUpdate().then(() => location.reload());
    });

    this.update.activated.subscribe((event) => {
      console.log(`current`, event.previous, `available `, event.current);
    });
  }
  addStyleSheet(fontLink) {
    var headID = document.getElementsByTagName('head')[0];
    var link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.id = 'widget_styles';
    headID.appendChild(link);
    link.href = fontLink;
  }
  addScript(linkurl) {
    var headID = document.getElementsByTagName('head')[0];
    var link = document.createElement('script');
    link.src = linkurl;
    link.async = true;
    headID.appendChild(link);
  }
}
